import { Card, CardContent, CardHeader, Typography, Grid2 as Grid, Stack, Box } from '@mui/material';
import React from 'react';
import { ListChildComponentProps } from 'react-window';
import { useTranslation } from 'react-i18next';
import { formatPhoneNumber } from '../../utils/phoneNumberUtils';
import { NewWindowLink } from '../NewWindowLink';
import { Dialogs } from '../../constants/Dialogs';
import { openDialog } from '../../ducks/dialogSlice';
import { useAppSelector, useAppDispatch } from '../../hooks';
import { setDealerDialog } from '../../ducks/dealersSlice';
import { getActionsMenuProps } from '../../utils/MUIDataGridUtils';
import { MUIDataGrid } from '../../constants/MUIDataGrid';
import { ActionsMenu } from '../ActionsMenu';

export const DealersCard: React.FC<ListChildComponentProps> = ({ style, data: dealers, index }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const dealer = dealers[index];
  const clientId = useAppSelector((state) => state?.clientData.clientId);

  return (
    <Card
      elevation={0}
      key={dealer.key}
      style={style}
      onClick={(): void => {
        dispatch(setDealerDialog({ dialogDealer: dealer, dialogClientId: clientId }));
        dispatch(openDialog({ dialog: Dialogs.Dealer }));
      }}
      sx={{
        p: '16px',
        borderRadius: '8px',
        height: 'fit-content !important',
        ml: '24px',
        width: 'calc(100% - 48px) !important',
      }}
    >
      <Stack direction="column" spacing="8px">
        <CardHeader
          title={
            <Typography variant="body1" fontWeight={600}>
              {dealer.name}
            </Typography>
          }
          sx={{ height: '24px', p: '0px', '& button': { position: 'absolute', top: '2px', right: '2px' } }}
          action={<NewWindowLink link={dealer.dealerURL} />}
        />
        <CardContent sx={{ p: '0px !important' }}>
          <Stack direction="column" spacing="8px">
            <Grid container>
              <Grid size={12}>
                <Typography color="textSecondary" variant="body2">
                  {`${dealer.city}, ${dealer.state}`}
                </Typography>
              </Grid>
            </Grid>

            <Grid container>
              <Grid size={12}>
                <Typography color="textSecondary" variant="body2">
                  {dealer.emailAddress}
                </Typography>
              </Grid>
            </Grid>

            <Grid container>
              <Grid size={12}>
                <Typography color="textSecondary" variant="body2">
                  {formatPhoneNumber(dealer.phoneNumber)}
                </Typography>
              </Grid>
            </Grid>

            <Box sx={{ position: 'absolute', bottom: '2px', right: '2px' }}>
              <ActionsMenu
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...getActionsMenuProps({ table: MUIDataGrid.Dealers, clientId, editable: false }, dealer, dispatch, t)}
              />
            </Box>
          </Stack>
        </CardContent>
      </Stack>
    </Card>
  );
};
